import { AxiosError, AxiosResponse } from 'axios'
import { camelize } from 'casing'
import {
  startLoading,
  stopLoading,
  LoadingTypes,
  errorLogger,
} from '@labrav/common'
import { getBuyerContractsAPI } from '../../api/marketplace/index'
import type { AppDispatch, RootState } from '../../store/types'

import { BuyerContractsActionTypes, Contracts } from './types'

export { BuyerContractsActionTypes }

export const getBuyerContracts =
  ({ partnerId, buyerId }: { partnerId: string; buyerId: string }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.BUYERS_OVERVIEW))
    try {
      const response = await getBuyerContractsAPI({ partnerId, buyerId })
      const contracts = camelize(response?.data)
      await dispatch(setBuyerContracts(contracts as Contracts))
    } catch (error: unknown) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      const globalState = getState()
      errorLogger({ globalState: globalState as never })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.BUYERS_OVERVIEW))
    }
  }

export const setBuyerContracts = (buyerContracts: Contracts) => ({
  type: BuyerContractsActionTypes.SET_BUYER_CONTRACTS,
  payload: buyerContracts,
})
